export function SaveTemplateRules(this: any) {
  return {
    templateId: this.templateId,
    ruleExpressions: this.ruleExpressions ?? [],
    id: this.templateId,
    group: this.groupName,
    templateName: this.templateName
  };
}
